import type { RouteRecordRaw } from 'vue-router';

export const infoProductCategoryRoutes: Array<RouteRecordRaw> = [
  {
    path: '/info/product/category',
    name: 'infoProductCategory',
    redirect: '/info/product/category/list',
    component: () => import('pages/info/productCategory/ProductCategory.vue'),
    meta: {
      title: 'Product Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:productId?/:groupId?/:appId?',
        name: 'infoProductCategoryList',
        component: () => import('pages/info/productCategory/ProductCategoryList.vue'),
        meta: {
          title: 'Product Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:productId?/:groupId?/:appId?',
        name: 'infoProductCategoryDetail',
        component: () => import('pages/info/productCategory/ProductCategoryDetail.vue'),
        meta: {
          title: 'Product Category Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new/productId?/:groupId?/:appId?',
        name: 'infoProductCategoryNew',
        component: () => import('pages/info/productCategory/ProductCategoryNew.vue'),
        meta: {
          title: 'New Product Category',
          requiresAuth: true,
        },
      },
    ],
  },
];
